
<div class="L-5 M-6 S-hide columns script-container" [ngClass]="{'fullscreen': isFullscreen}">
  <div class="box-subtittle">
    <div></div>
    <!-- <div class="L-4 M-4 S-4 columns">
      <select name="extras_call_type_id" [(ngModel)]="selectedCharacter">
        <option disabled selected>--</option>
        <option *ngFor="let character of listCharacters" [value]="character.id">
          {{ character?.character_name }}
        </option>
      </select>
    </div> -->

    <div>
      <!-- <span class="material-icons edit-icon" (click)="toggleDrawingMode()" *ngIf="!isDrawingMode">
        <span class="material-symbols-outlined">edit</span>
      </span> -->
      @if (!isDrawingMode) {
        <span class="material-icons fullscreen" (click)="toggleFullscreen()">
          <span class="material-symbols-outlined">{{isFullscreen ? 'fullscreen_exit' : 'fullscreen'}}</span>
        </span>
      }

      <!-- Drawing controls -->
      @if (isDrawingMode) {
        <div class="drawing-controls">
          <span class="material-icons control-icon save-icon" (click)="saveDrawing()">
            <span class="material-symbols-outlined">save</span>
          </span>
          <span class="material-icons control-icon delete-icon" (click)="clearDrawing()">
            <span class="material-symbols-outlined">delete</span>
          </span>
          <span class="material-icons control-icon cancel-icon" (click)="cancelDrawing()">
            <span class="material-symbols-outlined">close</span>
          </span>
        </div>
      }
    </div>
  </div>

  <div class="pageContainer">
    <div class="page sideScript grid">
      <span class="header-script">{{ scene ? _gS.backTranslate(scene, 'scene_header') : ''}}</span>
      <br>
        <br>
          <div class="pad_container" (mouseup)="onSelectedText($event)">
            @for (pr of script; track pr) {
              <p [class]="pr.type"[innerHTML]="pr.breakdown"></p>
            }
          </div>

          <!-- Canvas overlay for drawing -->
          @if (isDrawingMode) {
            <canvas class="drawing-canvas" id="breakdown-sketchpad"></canvas>
          }
        </div>
      </div>
    </div>
    <!-- <div *ngIf="_gS.showContext" class="filter-contextmenu" (click)="_gS.hidemenu($event);" [style.left]="_gS.contextmenux" [style.top]="_gS.contextmenuy"
    (click)="onClickBoxContext($event)">
    <div class="data-body form-data">
    </div>
  </div> -->
  @if (_gS.showContext) {
    <div class="contextmenuConteiner" (dbclick)="_gS.hidemenu()" (contextmenu)="_gS.hidemenu()">
      @if (_gS.showContext) {
        <div class="hidecontetx" (click)="_gS.hidemenu()"></div>
      }
      <div class="contextmenu menubreakdown " [style.left]="_gS.contextmenux" [style.top]="_gS.contextmenuy">
        <form [formGroup]="form" (ngSubmit)="saveBreakdown()">
          @if (error) {
            <div class="error"><span class="uppercase">{{error}}</span></div>
          }
          <div class="L-5 M-5 S-5 columns">
            <div class="flex justify-center align-center textname ">
              <div>
                <span class="material-icons more-icon circle-breakdown filled-breakdown" [ngClass]="{'active': view == 'add-face'}" (click)="changeView($event,'add-face')">
                  <span class="material-symbols-outlined">person</span>
                </span>
              </div>
              <div>
                <span class="material-icons more-icon circle-breakdown filled-breakdown" [ngClass]="{'active': view == 'add-fact_check'}" (click)="changeView($event,'add-fact_check')">
                  <span class="material-symbols-outlined">wine_bar</span>
                </span>
              </div>
              <div>
                <span class="material-icons more-icon circle-breakdown filled-breakdown" [ngClass]="{'active': view == 'add-event'}" (click)="changeView($event,'add-event')">
                  <span class="material-symbols-outlined">local_fire_department</span>
                </span>
              </div>
            </div>
          </div>
          @if (!loading) {
            <div style="margin-top: 10px;" class="L-12 M-12 S-12 columns " (click)="$event.stopPropagation()">
              <label>{{'Name' | translate}}
                @if (view == 'add-face') {
                  {{ 'Character' | translate }}
                }
                @if (view == 'add-fact_check') {
                  {{ 'Elements' | translate }}
                }
                @if (view == 'add-event') {
                  {{ 'Event' | translate }}
                }
              </label>
              <input  type="text" matInput #name name="name" [maxLength]="150" [formControlName]="'name'">
            </div>
          }
          @if (view == 'add-face') {
            <div style="margin-top: 10px;"class="L-12 M-12 S-12 columns">
              <label>{{'Character' | translate}}</label>
              <app-dropdown
                (appModelChange)="changeCharacter($event)"
                [list]="dropdowns.character_roles"
                [value]="'id'"
                [name]="'name'"
                [backTranslate]="true"
              ></app-dropdown>
            </div>
          }
          @if (view == 'add-fact_check') {
            <div style="margin-top: 10px;" class="L-12 M-12 S-12 columns">
              <label>{{'Elements' | translate}}</label>
              <app-dropdown
                (appModelChange)="changeElement($event)"
                [list]="dropdowns.element_categories"
                [value]="'id'"
                [name]="'name'"
                [backTranslate]="true"
              ></app-dropdown>
            </div>
          }
          @if (view == 'add-event') {
            <div style="margin-top: 10px;" class="L-12 M-12 S-12 columns">
              <label>{{'Event type' | translate}}</label>
              <app-dropdown
                (appModelChange)="changeEvent($event)"
                [list]="dropdowns.event_types"
                [value]="'id'"
                [name]="'name'"
                [backTranslate]="true"
              ></app-dropdown>
            </div>
          }
          @if (form.value.category_id > '4' && form.value.category_id <'7') {
            <div class="L-12 M-12 S-12 columns"  >
              <label>{{'Qty' | translate}}**</label>
              <input class="centered" [formControlName]="'quantity'" type="text"name placeholder="{{'Quantity' | translate}}"  [pattern]="_gS.regex.number"  maxlength="4" required>
            </div>
          }
          <!-- Submit -->
          <div style="margin-top: 8px;" class="L-12 M-12 S-12 columns TextCentered">
            <input name="sumbit" type="submit" [disabled]="!form.value.name || !form.value.category_id" value="{{'Save' | translate}}">
          </div>
        </form>
      </div>
    </div>
  }
